import styled from 'styled-components';

export const ResultWrap = styled.div`
  position: relative;

  > button {
    border: 0;
    background: transparent;
    width: 90%;
    height: 14%;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);

    &.copy {
      width: 16%;
      height: 4.5%;
      left: 63%;
      bottom: 8.5%;
    }

    &.kakao {
      width: 16%;
      height: 4.5%;
      left: 38%;
      bottom: 8.5%;
    }

    &.re-try {
      bottom: 0;
      width: 100%;
      height: 5%;
    }

    &.search {
      bottom: 44%;
      width: 100%;
      height: 4%;
    }
  }
`;
